<section class="app-hom-abo" [id]="HomeSection.ABOUT_US">
  <div class="container app-hom-abo__con">
    <div class="app-hom-abo__con__lef">
      <!-- <h2 class="app-hom-abo__con__lef__h2">O NAS</h2> -->
      <p class="app-hom-abo__con__lef__pin-bla">
        Misją PRO.CONNECT (L'Oréal Professionnel, Kérastase, Redken) jest wspieranie rozwoju sztuki fryzjerskiej w
        Polsce i inspirowanie do ciągłego doskonalenia.
      </p>

      <p class="app-hom-abo__con__lef__p">
        Chcesz zarabiać więcej i prowadzić trendujący biznes? Dołącz do nas i inwestuj w siebie i swój zespół dzięki
        ekskluzywnym szkoleniom. Bądź na bieżąco z trendami, zyskaj wsparcie ekspertów w zarządzaniu salonem i buduj
        silną markę.
        <span class="d-none d-md-inline">
          Nawiąż cenne kontakty i wymieniaj się doświadczeniami. PRO.CONNECT to proste rozwiązanie idealne dla Twojego
          salonu. Razem tworzymy społeczność, która podnosi standardy fryzjerstwa i wyznacza nowe kierunki w branży,
          dając Ci dostęp do najnowszej wiedzy, sprawdzonych strategii biznesowych i inspirujących wydarzeń, które
          pomogą Ci osiągnąć sukces. Dołącz do nas i rozwijaj swój biznes!
        </span>
        <span class="d-inline d-md-none">
          @if (expandedText() === false) {
            <a style="color: inherit; font-size: inherit; cursor: pointer" (click)="expandedText.set(!expandedText())"
              >Rozwiń ></a
            >
          }
          @if (expandedText()) {
            <span [appAnimate]="'landing'" [speed]="'fast'">
              Nawiąż cenne kontakty i wymieniaj się doświadczeniami. PRO.CONNECT to proste rozwiązanie idealne dla
              Twojego salonu. Razem tworzymy społeczność, która podnosi standardy fryzjerstwa i wyznacza nowe kierunki w
              branży, dając Ci dostęp do najnowszej wiedzy, sprawdzonych strategii biznesowych i inspirujących wydarzeń,
              które pomogą Ci osiągnąć sukces. Dołącz do nas i rozwijaj swój biznes!
              <a style="color: inherit; font-size: inherit; cursor: pointer" (click)="expandedText.set(!expandedText())"
                >< Zwiń</a
              >
            </span>
          }
        </span>
      </p>
    </div>
    <div class="app-hom-abo__con__rig">
      <img
        class="app-hom-abo__con__rig__bg"
        [priority]="true"
        alt="background"
        ngSrc="assets/images/pages/home/about-us-banner.webp"
        [fill]="true"
      />
    </div>
  </div>
</section>
